import { createSelector } from 'reselect';

const mailchimpCampaignData = (state) => state.crmEmail.mailchimpCampaignData;
const klaviyoAccountData = (state) => state.crmEmail.klaviyoAccountData;
const klaviyoCampaignData = (state) => state.crmEmail.klaviyoCampaignData;

export const mailChimpCampaignsSelector = createSelector(mailchimpCampaignData, (mailchimpCampaignData) => {
  return mailchimpCampaignData;
});

export const kavliyoAccountDataSelector = createSelector(klaviyoAccountData, (klaviyoAccountData) => {
  return klaviyoAccountData;
});

export const klaviyoCampaignDataSelector = createSelector(klaviyoCampaignData, (klaviyoCampaignData) => {
  return klaviyoCampaignData;
});
